export const ContactConstants = {
    phoneNumber: '1-800-842-8282',
    email: 'Cevo@EnterpriseWireless.org',
} as const;
